import { Input } from "baseui/input";
import { LabelLarge, LabelMedium } from 'baseui/typography';
import { Block } from 'baseui/block';
import { IControlledCoolingOutletPumpControl } from './types'

// api
import { FormattedMessage } from 'react-intl';
import { VscPassFilled, VscCircleLarge } from 'react-icons/vsc';
import { OperatorPanelWrapper } from '../../../components/Layout';
import { themedUseStyletron } from "../../../../theme/customTheme";
import { Checkbox, STYLE_TYPE } from "baseui/checkbox";
import { FormControl } from "baseui/form-control";
import { useSetObjectValue } from "../../../../hooks/useSetObjectValue";




export const OperatorPanel = (props: IControlledCoolingOutletPumpControl) => {
    const [css, theme] = themedUseStyletron();

    return (
        <OperatorPanelWrapper
            objectId={props.id}
            resourceGroupId={props.resourceGroupId}
            statusContent={
                <>
                {props.request &&
                    <>
                        <VscPassFilled color={theme.appColors.aggregate.on} size={theme.sizing.scale800}></VscPassFilled>
                        <LabelLarge><FormattedMessage id="Devices.ON" defaultMessage="ON" /></LabelLarge>
                    </>
                }
                {!props.request &&
                    <>
                        <VscCircleLarge color={theme.appColors.aggregate.off}  size={theme.sizing.scale800}></VscCircleLarge>
                        <LabelLarge color={theme.appColors.aggregate.off}><FormattedMessage id="Devices.OFF" defaultMessage="OFF" /></LabelLarge>
                    </>
                }
                
                </>
            }
            additionalContent={
                <>
            </>
            }
        >
        </OperatorPanelWrapper>

    )
}

